import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/helsinkiofficial/feed")({
  head: () => ({
    meta: [
      { title: "Helsinkiofficial Feed Posts — what Finland" },
      {
        name: "description",
        content:
          "Featured Helsinkiofficial Instagram feed posts curated by what Finland — the official storytelling channel for Helsinki.",
      },
      { property: "og:title", content: "Helsinkiofficial Feed Posts — what Finland" },
      {
        property: "og:description",
        content: "Featured Helsinkiofficial Instagram feed posts curated by what Finland.",
      },
    ],
  }),
  component: HelsinkiofficialFeedPage,
});

function HelsinkiofficialFeedPage() {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <header className="mb-10">
          <p className="text-sm uppercase tracking-wider text-neutral-500">Helsinkiofficial</p>
          <h1 className="text-4xl sm:text-5xl font-semibold mt-2">Feed Posts</h1>
          <p className="mt-4 text-lg text-neutral-700 max-w-2xl">
            Featured Instagram feed posts from{" "}
            <a
              href="https://instagram.com/helsinkiofficial"
              target="_blank"
              rel="noreferrer noopener"
              className="underline underline-offset-4"
            >
              @helsinkiofficial
            </a>
            , Helsinki's official social channel. New posts appear here as they're published.
          </p>
        </header>
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="aspect-square rounded-2xl bg-neutral-100 border border-neutral-200 flex items-center justify-center text-neutral-400 text-sm">
            Coming soon
          </div>
          <div className="aspect-square rounded-2xl bg-neutral-100 border border-neutral-200 flex items-center justify-center text-neutral-400 text-sm">
            Coming soon
          </div>
          <div className="aspect-square rounded-2xl bg-neutral-100 border border-neutral-200 flex items-center justify-center text-neutral-400 text-sm">
            Coming soon
          </div>
        </section>
      </div>
    </div>
  );
}
